import React, { useEffect } from 'react';
import styles from './VerificationStatistic.module.scss';

import Separator from 'components/Separator/Separator';
import { TransparentButton } from 'components/Buttons';

import DashboardWrapper from '../DashboardWrapper';
import SectionHeader from '../SectionHeader';

import VerificationStatisticTable from './Table';
import VerificationStatisticCharts from './Charts';

import AssetsDashboardsFilter from '../Filter';

import { useAssetsDashboardsActions, useAssetsDashboardsSelector } from 'hooks/AssetsDashboards';

import { fileDownload } from 'helpers/AppHelpers';

import csvIcon from 'assets/images/csvIcon.svg';

export default function VerificationStatistic() {
  const { verificationStatistic, tabConfig, tab } = useAssetsDashboardsSelector();
  const { getVerificationStatisticAction, getCsvResourceAction, clearTabStateAction } =
    useAssetsDashboardsActions();

  useEffect(() => {
    return () => {
      clearTabStateAction({ stateName: 'verificationStatistic' });
    };
  }, []);

  const getFilterData = (sectionId) => tabConfig?.items?.find(({ id }) => id === sectionId) || {};

  const applyFilter = () => getVerificationStatisticAction();

  const downloadCsv = (dashboardId) =>
    getCsvResourceAction({ dashboardId, dashboardType: tab }).then((res) => fileDownload(res));

  return (
    <DashboardWrapper>
      {!!verificationStatistic?.length && (
        <div className={styles.statistics}>
          {verificationStatistic.map((sectionData, index) => (
            <div key={sectionData.id} className={styles.statistics__dashboard}>
              <SectionHeader title={sectionData.name || ''} />
              <AssetsDashboardsFilter
                filter={getFilterData(sectionData.id)}
                onApply={applyFilter}
              />
              <TransparentButton
                label="Download CSV File"
                className={styles.csvButton}
                onClick={() => downloadCsv(sectionData.id)}>
                <img src={csvIcon} alt="" />
              </TransparentButton>
              <div className={styles.statistics__dashboard_info}>
                <VerificationStatisticTable data={sectionData} />
                <VerificationStatisticCharts data={sectionData} />
              </div>
              {verificationStatistic.length > 1 && index !== verificationStatistic.length - 1 && (
                <Separator />
              )}
            </div>
          ))}
        </div>
      )}
    </DashboardWrapper>
  );
}
